import type {
	HotelApplicationDataQueryQuery,
	TicketListAvailable_BillingPageQuery,
} from "@/lib/gql/__generated__/graphql";

import { useSettingsPaymentCreditDialog } from "../../../payment-credit/ui/dialog/dialog";
import * as UseCase from "../../model/use-case";
import { SettingsBillingDialog as Dialog } from "../_components/main/dialog";

import type { ServerModel } from "../../../payment-credit/repository";

type Props = {
	hotelID: string;
	paymentCreditServerModel: ServerModel;
	hotelApplicationData: HotelApplicationDataQueryQuery;
	availableTicketList: TicketListAvailable_BillingPageQuery;
};

export const DialogSettingsBillingPresenter = ({
	hotelID,
	paymentCreditServerModel,
	hotelApplicationData,
	availableTicketList,
}: Props) => {
	const { activateCreditCardSettingDialog, SettingsPaymentCreditDialog } = useSettingsPaymentCreditDialog({
		hotelID,
		serverModel: paymentCreditServerModel,
	});

	const {
		ticketBasicListAvailable,
		ticketProListAvailableContinuousBilling,
		ticketProListAvailableSingleBilling,

		isUsingPro,

		billingStatus,
		onPurchaseBasicBillingTicket,
		onPurchaseProBillingTicket,
		onRecurringPurchaseProBillingTicket,

		handleOpenChange,
		openBillingSettingDialog,
		activateBillingSettingDialog,
		deactivateBillingSettingDialog,
	} = UseCase.useInitialized({ hotelID, activateCreditCardSettingDialog, hotelApplicationData, availableTicketList });

	return (
		<>
			<Dialog
				hotelID={hotelID}
				ticketBasicListAvailable={ticketBasicListAvailable}
				ticketProListAvailableContinuousBilling={ticketProListAvailableContinuousBilling}
				ticketProListAvailableSingleBilling={ticketProListAvailableSingleBilling}
				isUsingPro={isUsingPro}
				billingStatus={billingStatus}
				onPurchaseBasicBillingTicket={onPurchaseBasicBillingTicket}
				onPurchaseProBillingTicket={onPurchaseProBillingTicket}
				onRecurringPurchaseProBillingTicket={onRecurringPurchaseProBillingTicket}
				activateBillingSettingDialog={activateBillingSettingDialog}
				deactivateBillingSettingDialog={deactivateBillingSettingDialog}
				openBillingSettingDialog={openBillingSettingDialog}
				handleOpenChange={handleOpenChange}
			/>

			{SettingsPaymentCreditDialog}
		</>
	);
};

DialogSettingsBillingPresenter.displayName = "DialogSettingsBillingPresenter";
